<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      /> 
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          class="flex flex-row w-full"
          ref="ruleForm"
        >
          <div class="w-full md:w-11.5/12 lg:max-w-detail lg:mr-auto">

            <base-collapsible-form 
              v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor')"
              ref="baseCollapsibleConfigLicenciamiento" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos de licenciamiento"}}</h2>
              </template>
              <template slot="content">

              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_clients')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumClients }} / {{ form.NumClientsTotal }}</span>
                  <el-progress :aria-label="$t('distributors.num_users')" class="w-full dark:text-darkblue-200" :percentage="percentageNumClients" :color="customColorMethod"></el-progress>
                </div>
              </div>

              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_neos')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumeroNotificacionesAnuales }} / {{ form.NumeroNotificacionesAnualesTotal }}</span>
                  <el-progress :aria-label="$t('distributors.num_neos')" class="w-full dark:text-darkblue-200" :percentage="percentageNumeroNotificacionesAnuales" :color="customColorMethod"></el-progress>
                </div>
              </div>
              
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.stored_space')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.StoredSpace }} / {{ form.StoredSpaceTotal }}</span>
                  <el-progress :aria-label="$t('distributors.stored_space')" class="w-full dark:text-darkblue-200" :percentage="percentageStoredSpace" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4" v-if="form.NumSMSTotal">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_sms')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumSMS }} / {{ form.NumSMSTotal }}</span>
                  <el-progress :aria-label="$t('distributors.num_sms')" class="w-full dark:text-darkblue-200" :percentage="percentageNumSMS" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_companies')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumCompanies }} / {{ form.NumCompaniesTotal }}</span>
                  <el-progress :aria-label="$t('clients.num_companies')" class="w-full dark:text-darkblue-200" :percentage="percentageNumCompanies" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_pgncif')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumeroSedesxCIFEmpresas }} / {{ form.NumeroSedesxCIFEmpresasTotal }}</span>
                  <el-progress :aria-label="$t('clients.num_pgncif')" class="w-full dark:text-darkblue-200" :percentage="percentageNumeroSedesxCIFEmpresas" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_users')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ form.NumUsers }} / {{ form.NumUsersTotal }}</span>
                  <el-progress :aria-label="$t('clients.num_users')" class="w-full dark:text-darkblue-200" :percentage="percentageNumUsers" :color="customColorMethod"></el-progress>
                </div>
              </div>
            

            </template>
          </base-collapsible-form>
          
            <!-- <h2 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{msgHeaderModules}}</h2> -->
              <base-collapsible-form 
                ref="baseCollapsibleModules" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderModules}}</h2>
                </template>
                <template slot="content">

                <div v-if="!isGeneralLoading && form.Modulos.length === 0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{msgEmptyModules}}</label>
                </div>
                
                <base-collapsible-form 
                  v-for="(cabecera, index) in form.Modulos"
                  :key="index"
                  :ref="'baseCollapsibleModules'+index" 
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                  <template slot="headerRight">
                    <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{cabecera.Descripcion}}</h3>
                  </template>
                  <template slot="content">

                    <div class="mb-4" 
                      v-for="modulo in cabecera.Modulos"
                      :key="modulo.idModulo">
                      <label :for="'switch-modulo-' + modulo.idModulo" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{modulo.Descripcion}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                      </label>
                      <div class="flex flex-col md:flex-row mt-2">
                        <el-switch 
                          :id="'switch-modulo-' + modulo.idModulo"
                          :aria-label="modulo.Descripcion"
                          class="switch-text break-normal both-switch" 
                          :disabled="true"
                          v-model="modulo.Contratado" 
                          :active-text="$t('app.active')" 
                          />
                        <label class="text-sm font-semibold dark:text-secondary-600 text-secondary-600 block mb-1 ml-0 md:ml-4">{{modulo.FechaCambioEstado}}</label>
                      </div>
                    </div>

                  </template>
                </base-collapsible-form>

                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                v-if="role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'"
                ref="baseCollapsibleConfigGeneral" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigModules}}</h2>
                </template>
                <template slot="content">

                  <div v-if="hasModuleCustomDownloadZIP">
                    <div class="flex flex-col lg:flex-row justify-between">              
                      <div class="w-full">
                        <label for="switch-config-download-zip" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                          {{$t('clients.config_download_zip')}}
                          <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                        </label>
                        <el-switch 
                          id="switch-config-download-zip"
                          :aria-label="$t('clients.config_download_zip')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.configDownloadZIP" 
                          :active-text="$t('companies.active')"/>
                      </div>
                      <div class="w-full mt-2 lg:mt-0">
                        <span id="clientadmin-max-size-zip-label" class="text-sm font-semibold text-secondary-600 block"></span>
                          <div class="flex items-center">
                            {{$t('clients.zip_max_size')}}
                            <base-tooltip-icon 
                              size="sm" 
                              :section="$t('clients.zip_max_size')"
                              :content="$t('tooltip.client.zip_max_size')" 
                              class="ml-2"/>
                          </div>
                          <div class="flex justify-between">
                            <el-form-item prop="maxSizeZIP" class="mt-2">
                              <el-input
                                class="w-full"
                                aria-labelledby="clientadmin-max-size-zip-label"
                                v-model.number="form.maxSizeZIP"
                                maxlength='2'
                                >
                                <template slot="append">MB</template>
                                <template v-if="form.maxSizeZIP" slot="suffix">
                                  <base-clear-input-button
                                    class="pt-2"
                                    aria-label="Limpiar campo de tamaño máximo ZIP"
                                    @clear="form.maxSizeZIP = ''"
                                  />
                                </template>
                              </el-input>
                            </el-form-item>
                          </div>        
                      </div>        
                    </div>
                  </div>

                <div v-if="hasModuleCustomDownloadZIP" class="mb-2">
                  <div class="flex flex-col lg:flex-row justify-between gap-x-2">              
                    <div class="w-full">
                      <label for="switch-zip-mail-download" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                        {{$t('clients.check_mail_zip_download')}}
                        <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                      </label>
                      <el-switch 
                        id="switch-zip-mail-download"
                        :aria-label="$t('clients.check_mail_zip_download')"
                        class="switch-text break-normal both-switch mt-2 mb-4" 
                        v-model="form.configZipMailDownload" 
                        :active-text="$t('companies.active')"/>         
                     </div>
                    <div class="w-full">
                      <label for="switch-zip-mail-vinc" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                        {{$t('clients.check_mail_zip_vinc')}}
                        <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                      </label>
                      <el-switch 
                        id="switch-zip-mail-vinc"
                        :aria-label="$t('clients.check_mail_zip_vinc')"
                        class="switch-text break-normal both-switch mt-2 mb-4" 
                        v-model="form.configZipMailVinc" 
                        :active-text="$t('companies.active')"/>         
                     </div>
                    <div class="w-full">
                      <label for="switch-zip-mail-manual" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                        {{$t('clients.check_mail_zip_manual')}}
                        <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                      </label>
                      <el-switch 
                        id="switch-zip-mail-manual"
                        :aria-label="$t('clients.check_mail_zip_manual')"
                        class="switch-text break-normal both-switch mt-2 mb-4" 
                        v-model="form.configZipMailManual" 
                        :active-text="$t('companies.active')"/>    
                     </div>
                  </div>
                </div>

                  <div v-if="hasModuleCustomDownloadZIP">
                    <span id="clientadmin-rename-zip-label" class="text-sm font-semibold text-secondary-600 block"></span>
                      <div class="flex items-center">
                        {{$t('clients.rename_zip')}}
                        <base-tooltip-icon 
                          size="sm" 
                          :section="$t('clients.rename_zip')"
                          :content="$t('tooltip.client.placeholderRenameZIP')" 
                          class="ml-2"/>
                      </div>
                      <div class="flex justify-between">
                        <el-form-item prop="renameZip" class="w-full">
                          <el-input
                            class="w-full"
                            aria-labelledby="clientadmin-rename-zip-label"
                            v-model="form.renameZip"
                            maxlength='300'
                          >
                            <template v-if="form.renameZip" slot="suffix">
                              <base-clear-input-button
                                aria-label="Limpiar campo de renombrar ZIP"
                                @clear="form.renameZip = ''"
                              />
                            </template>
                          </el-input>
                        </el-form-item>
                        <base-button 
                          class="mt-1 ml-4" 
                          style="width: 220px"
                          mode="primary" 
                          :text="$t('clients.new_metadata')" 
                          @click.prevent.stop="toggleInsertTag" 
                          :loading="isGeneralLoading"/>
                      </div>
                  </div>
            
                  <div class="mb-4 w-full lg:w-6/12 ">
                    <span id="clientadmin-dias-fecha-fin-tramite-label" class="text-sm font-semibold text-secondary-600">{{$t('clients.DiasFechaFinTramite')}}</span>
                    <el-form-item prop="DiasFechaFinTramite" class="mt-2">
                      <el-input
                        class="w-full"
                        aria-labelledby="clientadmin-dias-fecha-fin-tramite-label"
                        v-model="form.DiasFechaFinTramite"
                        maxlength='2'
                        :placeholder="$t('configurations.default_disabled')"
                        >
                        <template slot="append">días</template>
                        <template v-if="form.DiasFechaFinTramite" slot="suffix">
                          <base-clear-input-button
                            class="pt-2"
                            aria-label="Limpiar campo de días fecha fin trámite"
                            @clear="form.DiasFechaFinTramite = ''"
                          />
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>
                  
                  <div class="mb-4">
                    <label for="switch-gestionar-lista-blanca" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.gestionar_lista_blanca_grupos')}}
                      <span class="sr-only">{{$t('app.client')}} / {{$t('app.groups')}}</span>
                    </label>
                    <el-switch 
                      id="switch-gestionar-lista-blanca"
                      :aria-label="$t('clients.gestionar_lista_blanca_grupos')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.GestionarListaBlancaGrupos" 
                      :active-text="$t('app.groups')"
                      :inactive-text="$t('app.client')"
                      inactive-color="var(--primary-800)"/>
                  </div>
                  
                  <div class="mb-4" v-if="hasModuleDescargaAdjuntosPrincipales">
                    <label for="switch-descarga-adjuntos-principales" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.module_descarga_adjuntos_princ')}}
                      <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                    </label>
                    <el-switch 
                      id="switch-descarga-adjuntos-principales"
                      :aria-label="$t('clients.module_descarga_adjuntos_princ')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.DescargarSoloAdjuntosPrincipales" 
                      :active-text="$t('companies.active')"/>
                  </div>

                  <div class="mb-4">
                    <label for="switch-descargar-acuse" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.descargar_acuse')}}
                      <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                    </label>
                    <el-switch 
                      id="switch-descargar-acuse"
                      :aria-label="$t('clients.descargar_acuse')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.DescargarAcusePDF" 
                      :active-text="$t('companies.active')"/>
                  </div>

                  <div class="mb-4">
                    <label for="id-switch-ocultar-info" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.ocultar_info_empresas_certificados')}}
                      <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                    </label>
                    <el-switch 
                      id="id-switch-ocultar-info"
                      :aria-label="$t('clients.ocultar_info_empresas_certificados')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.OcultarInformacionEmpresasCertificados" 
                      :active-text="$t('companies.active')"/>
                  </div>

                  <div class="mb-4">
                    <label for="id-switch-enviar_correo_solo_descarga_automatica" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.enviar_correo_solo_descarga_automatica')}}
                      <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                    </label>
                    <el-switch 
                      id="id-switch-enviar_correo_solo_descarga_automatica"
                      :aria-label="$t('clients.enviar_correo_solo_descarga_automatica')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.EnviarCorreoSoloDescargaAutomatica" 
                      :active-text="$t('companies.active')"/>
                  </div>

                  <div class="mb-4">
                    <label for="id-switch-tramitar-diligencias-contestadas" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.tramitar_diligencias_contestadas')}}
                      <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                    </label>
                    <el-switch 
                      id="id-switch-tramitar-diligencias-contestadas"
                      :aria-label="$t('clients.tramitar_diligencias_contestadas')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.TramitarDiligenciasContestadas" 
                      :active-text="$t('companies.active')"/>
                  </div>

                </template>
              </base-collapsible-form>

                <base-collapsible-form 
                v-if="role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'"
                ref="baseCollapsibleConfigMails" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigMails}}</h2>
                </template>
                <template slot="content">
                  
                <div class="mb-4">
                  <label for="switch-days-groups-companies" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('clients.config_days_groups_companies')}}
                    <span class="sr-only">{{$t('app.companies')}} / {{$t('app.groups')}}</span>
                  </label>
                  <el-switch 
                    id="switch-days-groups-companies"
                    :aria-label="$t('clients.config_days_groups_companies')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.daysGroupsCompanies" 
                    :inactive-text="$t('app.companies')" 
                    :active-text="$t('app.groups')"
                    inactive-color="var(--primary-800)"
                    />
                </div>

                <div class="mb-4">
                  <label for="switch-mails-groups-gestion" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('clients.config_mails_groups_gestion')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-mails-groups-gestion"
                    :aria-label="$t('clients.config_mails_groups_gestion')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.mailsGroupsGestion" 
                    :active-text="$t('app.active')" 
                    />
                </div>
                
                <div class="mb-4">
                  <label for="switch-mails-to" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('clients.config_mails_to')}}
                    <span class="sr-only">{{$t('configurations.mails_to')}} / {{$t('configurations.mails_bcc')}}</span>
                  </label>
                  <el-switch 
                    id="switch-mails-to"
                    :aria-label="$t('clients.config_mails_to')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.mailsTo" 
                    :active-text="$t('configurations.mails_bcc')"
                    :inactive-text="$t('configurations.mails_to')"
                    inactive-color="var(--primary-800)"
                    />
                </div>
                    
                  <div class="mb-4"
                    :class="{'mt-10':isLower1024}">
                    <label for="switch-tramitar-auto" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_mails_tramitar_auto')}}
                      <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                    </label>
                    <el-switch 
                      id="switch-tramitar-auto"
                      :aria-label="$t('clients.config_mails_tramitar_auto')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.TramitarAuto" 
                      :active-text="$t('app.active')" 
                      />
                  </div>
                  
                  <div class="mb-4" v-if="form.EnviarAvisosCertSinVincular">
                    <span id="clientadmin-avisos-sin-cert-mails-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.avisos_sin_cert_mails')}}</span>
                    <el-form-item prop="EmailsAvisosCertSinVincular">
                      <el-input
                        class="w-full"
                        aria-labelledby="clientadmin-avisos-sin-cert-mails-label"
                        v-model="form.EmailsAvisosCertSinVincular"
                        maxlength='500'
                        >
                        <template v-if="form.EmailsAvisosCertSinVincular" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de emails"
                            @clear="form.EmailsAvisosCertSinVincular = ''"
                          />
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>

                </template>
              </base-collapsible-form>

              <!-- <h2 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{msgHeaderConfigUsers}}</h2> -->
              <base-collapsible-form 
                v-if="role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'"
                ref="baseCollapsibleConfigUsers" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigUsers}}</h2>
                </template>
                <template slot="content">
                  
                  <div class="mb-4">
                    <label for="switch-link-user-pool" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_link_user_pool')}}
                      <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                    </label>
                    <el-switch 
                      id="switch-link-user-pool"
                      :aria-label="$t('clients.config_link_user_pool')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.VincularUsuariosGrupoGestorNEOs" 
                      :active-text="$t('app.active')" 
                      />
                  </div>

                  <div class="lg:mb-2">
                    <AccessibleElSelect
                      v-model="form.mesesUserPass"
                      prop="mesesUserPass"
                      :options="mesesUserPassCaducForAccessibleSelect"
                      id-prefix="clientadmin"
                    >
                      <template slot="label">
                        <base-obligatory-icon/>
                        {{$t('clients.mesesUserPass')}}
                      </template>
                    </AccessibleElSelect>
                  </div>
                  <div class="mb-6">
                    <div class="flex flex-col lg:flex-row lg:space-x-4">
                      <div class="mb-4 lg:mb-0 w-full" v-if="hasModuleDobleFactor">
                        <label for="switch-require-otp" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('configurations.client_config_otp')}}
                          <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                        </label>
                        <el-switch 
                          id="switch-require-otp"
                          :aria-label="$t('configurations.client_config_otp')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.RequiereOTP"
                          :active-text="$t('app.active')" 
                        />
                      </div>
                      <div class="w-full">
                        <label for="switch-first-access" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('configurations.client_config_first_access')}}
                          <span class="sr-only">{{$t('app.inactive')}} / {{$t('app.active')}}</span>
                        </label>
                        <el-switch 
                          id="switch-first-access"
                          :aria-label="$t('configurations.client_config_first_access')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.CambioPassPrimerAcceso"
                          :active-text="$t('app.active')" 
                          />
                      </div>
                    </div>
                  </div>

                </template>
              </base-collapsible-form>

             <!-- <h2 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{msgHeaderConfigLists}}</h2> -->
             <base-collapsible-form 
                v-if="role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'"
              ref="baseCollapsibleWhiteMetadata" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_metadatas')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :section="$t('clients.config_admin_white_list_metadatas')"
                      :content="$t('tooltip.client.contentTooltipMetadataList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                <base-accessible-table
                  ref="whitelistmetadata"
                  :rows="formUnwatchable.ListaBlancaMetadatos"
                  :columns="whitelistMetadataColumns"
                  :rowKey="row => row.Nombre"
                  :enableScroll="true"
                  :maxBodyHeight="250"
                >
                  <template #cell-Nombre="{ row }">
                    <span :title="row.Nombre">{{ row.Nombre }}</span>
                  </template>
                  <template #cell-Tipo="{ row }">
                    <span :title="row.Tipo">{{ row.Tipo }}</span>
                  </template>
                  <template #cell-actions="{ row }">
                    <div class="flex flex-row justify-center">
                      <base-button-icon 
                        v-if="row.EsLista"
                        @click="addValueToListMetadataToggleDialog({ row })" name="editpencil" mode="core" size="xs" ariaLabel="Añadir valor"/>
                      <base-button-icon 
                        v-if="hasModuleImportaciones && row.EsLista"
                        @click="toggleImport({ row })" name="import" mode="core" size="xs" ariaLabel="Importar valores"/>
                      <base-button-icon @click="deleteMetadatoAdicional(row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar metadato" />
                    </div>
                  </template>
                </base-accessible-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('notificationFilter.new_metadata')"
                    @click="newMetadatoToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                  />
                </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                v-if="role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'"
              ref="baseCollapsibleWhiteEmails" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_emails')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :section="$t('clients.config_admin_white_list_emails')"
                      :content="$t('tooltip.client.contentTooltipWhiteList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                <base-accessible-table
                  ref="whitelistemails"
                  :rows="formUnwatchable.ListaBlancaEmails"
                  :columns="whitelistEmailsColumns"
                  :rowKey="row => row.Nombre"
                  theadClass="sr-only"
                  :enableScroll="true"
                  :maxBodyHeight="250"
                >
                  <template #cell-Nombre="{ row }">
                    <span :title="row.Nombre">{{ row.Nombre }}</span>
                  </template>
                  <template #cell-actions="{ row }">
                    <div class="flex flex-row justify-end">
                      <!-- <base-button-icon @click="editListaBlancaEmail(row)" name="editpencil" mode="core" size="xs" /> -->
                      <base-button-icon @click="deleteListaBlancaEmail(row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar email de lista blanca" />
                    </div>
                  </template>
                </base-accessible-table>
                <div class="w-full flex flex-wrap justify-end items-center gap-x-2 mt-5 mb-5">
                  <base-button-responsive
                    v-if="visibleDeleteAllWhiteMail"
                    mode="primary"
                    :text="$t('app.delete_all')"
                    @click="deleteAllWhiteMailToggleDialog()"
                    icon="trash"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('app.export_excel')"
                    @click="exportExcelWhiteMail()"
                    icon="excelxls"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('app.import_emails')"
                    @click="toggleImportEmail()"
                    icon="import"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('clients.add_email')"
                    @click="newWhiteMailToggleDialog()"
                    icon="plus"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
                v-if="role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'"
              ref="baseCollapsibleBlackEmails" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-6">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_black_list_emails')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :section="$t('clients.config_admin_black_list_emails')"
                      :content="$t('tooltip.client.contentTooltipBlackList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                <base-accessible-table
                  ref="blacklistemails"
                  :rows="formUnwatchable.ListaNegraEmails"
                  :columns="blacklistEmailsColumns"
                  :rowKey="row => row.Nombre"
                  theadClass="sr-only"
                  :enableScroll="true"
                  :maxBodyHeight="250"
                >
                  <template #cell-Nombre="{ row }">
                    <span :title="row.Nombre">{{ row.Nombre }}</span>
                  </template>
                  <template #cell-actions="{ row }">
                    <div class="flex flex-row justify-end">
                      <!-- <base-button-icon @click="editListaNegraEmail(row)" name="editpencil" mode="core" size="xs" /> -->
                      <base-button-icon @click="deleteListaNegraEmail(row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar email de lista negra" />
                    </div>
                  </template>
                </base-accessible-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('clients.add_email')"
                    @click="newBlackMailToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                  />
                </div>
                </template>
              </base-collapsible-form>

          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive 
            v-if="!isRoleUserOrConsulta && role !== 'AdminDistribuidor' && role !== 'SuperAdminDistribuidor'" 
            mode="primary" 
            :text="$t('app.save')" 
            icon="save" 
            @click="submitForm('ruleForm')" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <BaseElDialog
        :title="$t('clients.delete_white_list_emails')"
        :visible.sync="showModalDeleteWhiteMail"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteWhiteMail }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
            <base-button class="w-full" @click="showModalDeleteWhiteMail = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {submitActionDeleteWhiteMail(); showModalDeleteWhiteMail = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <input-create-metadata-dialog
        :dialogOpen="showModalMetadato" 
        @toggleDialog="newMetadatoToggleDialog" 
        @applyDialog="applyNewMetadatoDialog"
        header="Añadir nuevo metadato" 
        />
      <input-modify-metadata-dialog
        :dialogOpen="showModalAddListMetadata" 
        @toggleDialog="addValueToListMetadataToggleDialog" 
        @applyDialog="applyModifyMetadatoDialog"
        header="Modificar valores" 
        :campoMetadato="actualMetadataSelected"
        :tipoMetadato="actualTypeSelectedNumber"
        />
      <input-text-mail-dialog 
        :dialogOpen="showModalWhiteMail" 
        @toggleDialog="newWhiteMailToggleDialog" 
        @applyDialog="applyNewWhiteMailDialog"
        header="Añadir nuevo email a la lista blanca" 
        headerValue="Nuevo email" 
        />
      <input-text-mail-dialog 
        :dialogOpen="showModalBlackMail" 
        @toggleDialog="newBlackMailToggleDialog" 
        @applyDialog="applyNewBlackMailDialog"
        header="Añadir nuevo email a la lista negra" 
        headerValue="Nuevo email" 
        />
        <BaseElDialog
          title="Inserción de metadato"
          :visible.sync="showModalTag"
            :close-on-click-modal="!isSelectDropdownOpen"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-insert-metadata-body',
              'container-handleOpenModal-insert-metadata',
              ])"
            @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-insert-metadata-body"
            >
            <el-form
              :model="formTag"
              ref="tagRules"
              :rules="tagRules"
            >
              <div class="lg:mb-2">
                <AccessibleElSelect
                  v-model="formTag.tag"
                  prop="tag"
                  :options="tagsForAccessibleSelect"
                  :group="true"
                  clearable
                  :loading="tagsLoading"
                  id-prefix="clientadmin-tag"
                >
                  <template slot="label">
                    <base-obligatory-icon/>
                    {{$t('app.tag_metadato')}}
                  </template>
                </AccessibleElSelect>
              </div>
            </el-form>
          </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-insert-metadata">
              <base-button class="w-full" @click.stop.prevent="showModalTag = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {insertTag('tagRules')}"/>
            </div>
          </template>
        </BaseElDialog>
        <import-generic-dialog
          :dialogOpen="showModalImport" 
          @toggleDialog="toggleImport" 
          @applyDialog="applyImport"
          @downloadTemplate="downloadTemplate"
          :getClientActive="false"
          header="Importación de valores a Metadato de tipo Lista" 
          />
          <import-generic-dialog
          :dialogOpen="showModalImportEmail" 
          @toggleDialog="toggleImportEmail" 
          @applyDialog="applyImportEmail"
          @downloadTemplate="downloadTemplateEmail"
          :getClientActive="false"
          header="Importación de Emails" 
          />
      <!-- <service-generate-password-dialog
        :dialogOpen="showModifyServicePassword"
        @toggleDialog="toggleDialogs"
      /> -->
    </template>
  </detail-layout>
</template>

<script>
import { bus } from '@/main'

import { getClientConfig } from '@/services/clients/getClientConfig'
import { getDistModulos } from '@/services/distributors/getDistModulos'
import { updateClientConfig } from '@/services/clients/updateClientConfig'
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { getWhiteListEmails } from '@/services/clients/lists/getWhiteListEmails'
import { getBlackListEmails } from '@/services/clients/lists/getBlackListEmails'
import { newListMetadatas } from '@/services/clients/lists/newListMetadatas'
import { updateNameMetadata } from '@/services/clients/lists/updateNameMetadata' 
import { newWhiteListEmails } from '@/services/clients/lists/newWhiteListEmails'
import { newBlackListEmails } from '@/services/clients/lists/newBlackListEmails'
import { deleteListMetadatas } from '@/services/clients/lists/deleteListMetadatas'
import { deleteWhiteListEmails } from '@/services/clients/lists/deleteWhiteListEmails'
import { deleteBlackListEmails } from '@/services/clients/lists/deleteBlackListEmails'
import { getTagsMetadatosCliente } from '@/services/clients/getTagsMetadatosCliente'
import { getWhiteMailExcel } from '@/services/clients/getWhiteMailExcel' 
import { deleteAllWhiteListEmails } from '@/services/clients/lists/deleteAllWhiteListEmails'
import InputCreateMetadataDialog from '@/components/InputCreateMetadataDialog.vue'
import InputModifyMetadataDialog from '@/components/InputModifyMetadataDialog.vue'

import { MESES_USER_PASS_CADUC } from '@/config/meses-user-pass-caduc'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'
import InputTextMailDialog from '@/components/InputTextMailDialog.vue'
import { email as emailRegex } from '@/utils/regex'

import { i18n } from '@/i18n'
import moment from 'moment'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importValoresMetadato } from '@/services/configurations/imports/importValoresMetadato'
import { importListaBlancaEmailsCliente } from '@/services/configurations/imports/importListaBlancaEmailsCliente'
import { downloadTemplateValoresMetadato } from '@/services/configurations/imports/downloadTemplateValoresMetadato'
import { downloadTemplateListaBlancaEmails } from '@/services/configurations/imports/downloadTemplateListaBlancaEmails'
import BaseAccessibleTable from '@/components/tables/BaseAccessibleTable.vue'

function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}

function isValidNumLicense (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 9999999) {
      return true
    }
  }
  return false
}
function isValidDayEnd (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 30) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'client-admin-detail',
  components: {
    DetailLayout,
    AccessibleElSelect,
    InputCreateMetadataDialog,
    InputModifyMetadataDialog,
    InputTextMailDialog,
    BaseElDialog,
    ImportGenericDialog,
    BaseAccessibleTable,
    // ServiceGeneratePasswordDialog,
  },
  data: function () {
    return {
      showModifyServicePassword: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: i18n.t('configurations.config_admin'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
      },
      showModalMetadato: false,
      showModalWhiteMail: false,
      showModalBlackMail: false,
      showModalImport: false,
      showModalImportEmail: false,
      lastMetadatoImport: '',
      showModalAddListMetadata: false,
      showModalDeleteWhiteMail: false,
      processMessageDeleteWhiteMail: this.$i18n.t('clients.delete_white_list_emails_msg'),
      actualMetadataSelected: '',
      actualTypeSelected: 0,
      msgHeaderModules: this.$i18n.t('clients.modules'),
      msgHeaderConfigModules: this.$i18n.t('clients.config_general'),
      msgHeaderConfigUsers: this.$i18n.t('clients.config_admin_users'),
      msgHeaderConfigMails: this.$i18n.t('clients.config_admin_mails'),
      msgHeaderConfigLists: this.$i18n.t('clients.config_admin_lists'),
      msgEmptyModules: this.$i18n.t('clients.modules_empty'),
      msgEmptyDate: this.$i18n.t('clients.modules_empty_date'),
      mesesUserPassCaduc: MESES_USER_PASS_CADUC,
      formTag: {
        tag: null,
      },
      tags: [],
      tagsLoading: false,
      showModalTag: false,
      form: {
        // UsuarioServicio: null,
        NumClients: 0,
        NumeroNotificacionesAnuales: 0,
        StoredSpace: 0,
        NumSMS: 0,
        NumCompanies: 0,
        NumeroSedesxCIFEmpresas: 0,
        NumUsers: 0,

        NumClientsTotal: 0,
        NumeroNotificacionesAnualesTotal: 0,
        StoredSpaceTotal: 0,
        NumSMSTotal: 0,
        NumCompaniesTotal: 0,
        NumeroSedesxCIFEmpresasTotal: 0,
        NumUsersTotal: 0,

        mesesUserPass: 0,
        Modulos: [],

        GestionarListaBlancaGrupos: false,
        DescargarSoloAdjuntosPrincipales: false,
        DescargarAcusePDF: false,
        OcultarInformacionEmpresasCertificados: false,
        EnviarCorreoSoloDescargaAutomatica: false,
        TramitarDiligenciasContestadas: false,

        mailsGroupsGestion: false,
        TramitarAuto: false,
        EnviarAvisosCertSinVincular: false,
        EmailsAvisosCertSinVincular: '',
        daysGroupsCompanies: true,
        mailsTo: false,
        VincularUsuariosGrupoGestorNEOs: false,
        renameZip: '',
        configDownloadZIP: false,
        configZipMailDownload: false,
        configZipMailVinc: false,
        configZipMailManual: false,
        maxSizeZIP: null,
        DiasFechaFinTramite: null,

        RequiereOTP: false,
        CambioPassPrimerAcceso: false,
      },
      formUnwatchable: {
        ListaBlancaMetadatos: [],
        ListaBlancaEmails: [],
        ListaNegraEmails: [],
      },
      tagRules: {
        tag: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      rules: {
        DiasFechaFinTramite: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isDayValidEnd, trigger: 'blur' }
        ],
        EmailsAvisosCertSinVincular: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailMultipleValid, trigger: 'blur' }
        ],
        maxSizeZIP: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    visibleDeleteAllWhiteMail () {
      return this.formUnwatchable?.ListaBlancaEmails?.length > 0
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    hasModuleCustomDownloadZIP () {
      return this.$store.getters['auth/hasModuleCustomDownloadZIP']
    },
    hasModuleDescargaAdjuntosPrincipales () {
      return this.$store.getters['auth/hasModuleDescargaAdjuntosPrincipales']
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor']
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    percentageNumClients: function () {
      if (this.form.NumClients === 0 || this.form.NumClientsTotal === 0) return 0
      return Math.round((parseInt(this.form.NumClients) * 100) / parseInt(this.form.NumClientsTotal)) 
    },
    percentageNumeroNotificacionesAnuales: function () {
      if (this.form.NumeroNotificacionesAnuales === 0 || this.form.NumeroNotificacionesAnualesTotal === 0) return 0
      return Math.round((parseInt(this.form.NumeroNotificacionesAnuales) * 100) / parseInt(this.form.NumeroNotificacionesAnualesTotal)) 
    },
    percentageStoredSpace: function () {
      if (this.form.StoredSpace === 0 || this.form.StoredSpaceTotal === 0) return 0
      return Math.round((parseInt(this.form.StoredSpace) * 100) / parseInt(this.form.StoredSpaceTotal)) 
    },
    percentageNumSMS: function () {
      if (this.form.NumSMS === 0 || this.form.NumSMSTotal === 0) return 0
      return Math.round((parseInt(this.form.NumSMS) * 100) / parseInt(this.form.NumSMSTotal)) 
    },
    percentageNumCompanies: function () {
      if (this.form.NumCompanies === 0 || this.form.NumCompaniesTotal === 0) return 0
      return Math.round((parseInt(this.form.NumCompanies) * 100) / parseInt(this.form.NumCompaniesTotal)) 
    },
    percentageNumeroSedesxCIFEmpresas: function () {
      if (this.form.NumeroSedesxCIFEmpresas === 0 || this.form.NumeroSedesxCIFEmpresasTotal === 0) return 0
      return Math.round((parseInt(this.form.NumeroSedesxCIFEmpresas) * 100) / parseInt(this.form.NumeroSedesxCIFEmpresasTotal)) 
    },
    percentageNumUsers: function () {
      if (this.form.NumUsers === 0 || this.form.NumUsersTotal === 0) return 0
      return Math.round((parseInt(this.form.NumUsers) * 100) / parseInt(this.form.NumUsersTotal)) 
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    distLibre () {
      return this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    actualTypeSelectedNumber () {
      return this.actualTypeSelected === 'Lista autoalimentable' ? 1
        : this.actualTypeSelected === 'Lista no autoalimentable' ? 2
          : 0
    },
    mesesUserPassCaducForAccessibleSelect () {
      return this.mesesUserPassCaduc.map(tipo => ({
        id: tipo.id,
        value: tipo.id,
        name: tipo.name
      }))
    },
    tagsForAccessibleSelect () {
      return this.tags.map(group => ({
        label: group.Tipo,
        options: group.Metadatos ? group.Metadatos.map(item => ({
          id: item.Tag,
          value: item.Tag,
          name: item.Descripcion
        })) : []
      }))
    },
    whitelistMetadataColumns () {
      return [
        { key: 'Nombre', label: 'Nombre', align: 'left' },
        { key: 'Tipo', label: 'Tipo', width: '150px', align: 'left' },
        { key: 'actions', label: 'Acciones', width: '120px', align: 'center' },
      ]
    },
    whitelistEmailsColumns () {
      return [
        { key: 'Nombre', label: 'Nombre', align: 'left' },
        { key: 'actions', label: '-', width: '80px', align: 'center' },
      ]
    },
    blacklistEmailsColumns () {
      return [
        { key: 'Nombre', label: 'Nombre', align: 'left' },
        { key: 'actions', label: '-', width: '80px', align: 'center' },
      ]
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    showModalTag (newValue, oldValue) {
      if (!newValue) {
        this.formTag.tag = ''
      } else {
        this.handleGetTagsMetadatosCliente()
      }
    },
  },
  created: async function () {
    const config = await this.downloadData()
    this.setConfig(config)
    if (this.role !== 'AdminDistribuidor' && this.role !== 'SuperAdminDistribuidor') {
      this.downloadListMetada()
      this.downloadListwhiteEmail()
      this.downloadListBlackEmail()

      // this.handleGetTagsMetadatosCliente()
    }

    const breadcrumbs = []
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor') {
      // if (this.distLibre) {
      //   this.$refs.baseCollapsibleModules.toggle()
      // } else {
      this.$refs.baseCollapsibleConfigLicenciamiento.toggle()
      // }
    }
    this.resetControlFormChanges()
  },
  methods: {
    deleteAllWhiteMailToggleDialog () {
      this.showModalDeleteWhiteMail = !this.showModalDeleteWhiteMail
    },
    submitActionDeleteWhiteMail: async function () {
      this.$store.commit('app/setLoading', true)
      try {
        await this.exportExcelWhiteMail()
        const response = await deleteAllWhiteListEmails()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    exportExcelWhiteMail: async function () {
      this.$store.commit('app/setLoading', true)
      try {
        const response = await getWhiteMailExcel()
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'lista-blanca-emails.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    isDayValidEnd: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayEnd(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_fin_tramite'), callback)
      } else {
        callback()
      }
    },
    isNumberValid: function (rule, value, callback) {
      if ((!value || value === '')) {
        callback()
      } else if (!isValidNumLicense(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.number'), callback)
      } else {
        callback()
      }
    },
    toggleImport (scope = null) {
      this.lastMetadatoImport = scope?.row?.Nombre
      this.showModalImport = !this.showModalImport
    },
    toggleImportEmail () {
      this.showModalImportEmail = !this.showModalImportEmail
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importValoresMetadato(file, { Campo: this.lastMetadatoImport })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImport() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportEmail: async function (file) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importListaBlancaEmailsCliente(file)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportEmail() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateValoresMetadato()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-valores-metadato.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateEmail: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateListaBlancaEmails()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-emails.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    handleGetTagsMetadatosCliente: async function () {
      if (this.hasModuleCustomDownloadZIP) {
        this.tagsLoading = true
        this.tags = []
        const dataMetadatosCliente = await getTagsMetadatosCliente()
        if (dataMetadatosCliente.blnError === false) {
          this.tags = dataMetadatosCliente.Respuesta
        } else {
          this.doFeedback(dataMetadatosCliente.msgError + ' [Código de error: ' + dataMetadatosCliente.codError + ']')
        }
        this.tagsLoading = false
      }
    },
    toggleInsertTag () {
      this.showModalTag = !this.showModalTag
    },
    insertTag: async function (ruleForm) {
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            let newValue = ''
            if (this.form.renameZip) newValue = this.form.renameZip
            newValue += this.formTag.tag
            this.form.renameZip = newValue
            this.showModalTag = false
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        console.log(error)
        this.doFeedback()
      }
    },
    customColorMethod: function (percentage) {
      if (this.distLibre) {
        return 'var(--primary-400)'
      }
      if (percentage >= 80) {
        return '#FF382C'
      } else {
        if (this.darkMode) return 'var(--primary-400)'
        else return 'var(--primary-800)'
      }
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Campo: row.Nombre }
        const response = await deleteListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newMetadatoToggleDialog () {
      this.showModalMetadato = !this.showModalMetadato
    },
    addValueToListMetadataToggleDialog (scope) {
      this.actualMetadataSelected = scope?.row?.Nombre || ''
      this.actualTypeSelected = scope?.row?.Tipo || 0
      this.showModalAddListMetadata = !this.showModalAddListMetadata
    },
    deleteListaBlancaEmail: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: row.Nombre }
        const response = await deleteWhiteListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    deleteListaNegraEmail: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: row.Nombre }
        const response = await deleteBlackListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListBlackEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newBlackMailToggleDialog () {
      this.showModalBlackMail = !this.showModalBlackMail
    },
    applyNewMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: metadato.value, 
          Tipo: metadato.type,
          idCliente: this.id,
        }
        const response = await newListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newMetadatoToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyModifyMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        metadato.idCliente = this.id
        const response = await updateNameMetadata(metadato)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.addValueToListMetadataToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyNewWhiteMailDialog: async function (email) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: email }
        const response = await newWhiteListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newWhiteMailToggleDialog()
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyNewBlackMailDialog: async function (email) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: email }
        const response = await newBlackListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newBlackMailToggleDialog()
          this.downloadListBlackEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadListMetada: async function () {
      try {
        const result = await getListMetadatas()
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaBlancaMetadatos = result.Respuesta.map(x => ({ Nombre: x.Campo, EsLista: x.EsLista, Tipo: x.Tipo }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    downloadListwhiteEmail: async function () {
      try {
        const result = await getWhiteListEmails()
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaBlancaEmails = result.Respuesta.map(x => ({ Nombre: x }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    downloadListBlackEmail: async function () {
      try {
        const result = await getBlackListEmails()
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaNegraEmails = result.Respuesta.map(x => ({ Nombre: x }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    toggleDialogs: function () {
      this.showModifyServicePassword = !this.showModifyServicePassword
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailMultipleValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email_multiple'), callback)
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            MesesUserPass: this.form.mesesUserPass,
            EnviarMailGruposNoPropietarios: this.form.mailsGroupsGestion,
            TramitarAuto: this.form.TramitarAuto,
            EmailsAvisosCertSinVincular: this.form.EmailsAvisosCertSinVincular,
            GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
            EnviarMailCopiaOculta: this.form.mailsTo,
            VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
            DescargarSoloAdjuntosPrincipales: this.form.DescargarSoloAdjuntosPrincipales,
            DescargarAcusePDF: this.form.DescargarAcusePDF,
            OcultarInformacionEmpresasCertificados: this.form.OcultarInformacionEmpresasCertificados,
            EnviarCorreoSoloDescargaAutomatica: this.form.EnviarCorreoSoloDescargaAutomatica,
            TramitarDiligenciasContestadas: this.form.TramitarDiligenciasContestadas,
            DiasFechaFinTramite: parseInt(this.form.DiasFechaFinTramite),
            GestionarListaBlancaGrupos: this.form.GestionarListaBlancaGrupos,
            RenombradoZIP: this.form.renameZip,
            AdjuntarZIP: this.form.configDownloadZIP,
            EnviarZipAvisoDescargaNotificacion: this.form.configZipMailDownload,
            EnviarZipAvisoNotificacionVinculadaEnlace: this.form.configZipMailVinc,
            EnviarZipAvisoNotificacionEnvioManual: this.form.configZipMailManual,
            AdjuntoEmailMaxSize: this.form.maxSizeZIP,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
          }
          const response = await updateClientConfig(payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Configuración guardada correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    downloadData: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        let template
        if (this.role !== 'AdminDistribuidor' && this.role !== 'SuperAdminDistribuidor') {
          template = await getClientConfig()
        } else {
          template = await getDistModulos()
        }
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setConfig: function (config) {
      if (config) {
        if (config.Cliente) {
          this.form.mesesUserPass = config.Cliente.MesesUserPass ? config.Cliente.MesesUserPass : 0
          this.form.mailsGroupsGestion = config.Cliente.EnviarMailGruposNoPropietarios
          this.form.TramitarAuto = config.Cliente.TramitarAuto
          this.form.EnviarAvisosCertSinVincular = config.Cliente.EnviarAvisosCertSinVincular
          this.form.EmailsAvisosCertSinVincular = config.Cliente.EmailsAvisosCertSinVincular
          this.form.daysGroupsCompanies = config.Cliente.GestionarDiasAvisosGrupos
          this.form.mailsTo = config.Cliente.EnviarMailCopiaOculta
          this.form.VincularUsuariosGrupoGestorNEOs = config.Cliente.VincularUsuariosGrupoGestorNEOs
          this.form.DescargarSoloAdjuntosPrincipales = config.Cliente.DescargarSoloAdjuntosPrincipales
          this.form.DescargarAcusePDF = config.Cliente.DescargarAcusePDF
          this.form.OcultarInformacionEmpresasCertificados = config.Cliente.OcultarInformacionEmpresasCertificados
          this.form.EnviarCorreoSoloDescargaAutomatica = config.Cliente.EnviarCorreoSoloDescargaAutomatica
          this.form.TramitarDiligenciasContestadas = config.Cliente.TramitarDiligenciasContestadas
          this.form.DiasFechaFinTramite = config.Cliente.DiasFechaFinTramite !== null ? config.Cliente.DiasFechaFinTramite : null
          this.form.GestionarListaBlancaGrupos = config.Cliente.GestionarListaBlancaGrupos
          this.form.renameZip = config.Cliente.RenombradoZIP
          this.form.configDownloadZIP = config.Cliente.AdjuntarZIP
          this.form.configZipMailDownload = config.Cliente.EnviarZipAvisoDescargaNotificacion
          this.form.configZipMailVinc = config.Cliente.EnviarZipAvisoNotificacionVinculadaEnlace
          this.form.configZipMailManual = config.Cliente.EnviarZipAvisoNotificacionEnvioManual
          this.form.maxSizeZIP = config.Cliente.AdjuntoEmailMaxSize

          this.form.CambioPassPrimerAcceso = !!config.Cliente.CambioPassPrimerAcceso
          this.form.RequiereOTP = !!config.Cliente.RequiereOTP
        }

        // Modulos
        const cabeceras = config.Cabeceras
        cabeceras.forEach(cabecera => {
          cabecera.Modulos.forEach(x => {
            if (x.FechaCambioEstado) x.FechaCambioEstado = this.formatDate(x.FechaCambioEstado)
            else x.FechaCambioEstado = this.msgEmptyDate
          })
        })
        this.form.Modulos = cabeceras

        this.form.NumClients = config.NumeroClientes ? config.NumeroClientes : 0
        this.form.NumeroNotificacionesAnuales = config.NumeroNotificacionesAnuales ? config.NumeroNotificacionesAnuales : 0
        this.form.StoredSpace = config.Espacio ? config.Espacio : 0
        this.form.NumSMS = config.NumeroSMS ? config.NumeroSMS : 0
        this.form.NumCompanies = config.NumeroCIFEmpresas ? config.NumeroCIFEmpresas : 0
        this.form.NumeroSedesxCIFEmpresas = config.NumeroSedesxCIFEmpresas ? config.NumeroSedesxCIFEmpresas : 0
        this.form.NumUsers = config.NumeroUsuarios ? config.NumeroUsuarios : 0

        this.form.NumClientsTotal = config.NumeroClientesTotal ? config.NumeroClientesTotal : 0
        this.form.NumeroNotificacionesAnualesTotal = config.NumeroNotificacionesAnualesTotal ? config.NumeroNotificacionesAnualesTotal : 0
        this.form.StoredSpaceTotal = config.EspacioTotal ? config.EspacioTotal : 0
        this.form.NumSMSTotal = config.NumeroSMSTotal ? config.NumeroSMSTotal : 0
        this.form.NumCompaniesTotal = config.NumeroCIFEmpresasTotal ? config.NumeroCIFEmpresasTotal : 0
        this.form.NumeroSedesxCIFEmpresasTotal = config.NumeroSedesxCIFEmpresasTotal ? config.NumeroSedesxCIFEmpresasTotal : 0
        this.form.NumUsersTotal = config.NumeroUsuariosTotal ? config.NumeroUsuariosTotal : 0

        // this.form.UsuarioServicio = config.UsuarioServicio ? config.UsuarioServicio : null
      }
      this.resetControlFormChanges()
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
